import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  // Both hosting targets are built in production mode, so distinguish dev-hosting/localhost
  // from prod by hostname rather than import.meta.env.MODE.
  const host = window.location.hostname;
  const environment =
    host.includes("-dev") || host === "localhost" || host.startsWith("127.")
      ? "development"
      : "production";

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment,
  });
}
